import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classes from './AddPortalUser.module.css';

import { ListBox } from "primereact/listbox";
import Input from "../../components/CustomDropDown/Input/Input";
import Button1 from "../../components/UI/Button/Button1";
import { addUserToGroup, UserPowerSearch } from "../../Api Methods/Api";
import { Button } from "primereact/button";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const emailReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: emailRegex.test(action.val) };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}


const AddPortalUser = ({setSuccess, setFail, groupID, setShowPrevDialogs}) => {
    const [formIsValid, setFormIsValid] = useState(false);
    const [emailState, dispatchEmail] = useReducer(emailReducer, {
        value: '',
        isValid: null
    });
    const emailInputRef = useRef();
    const { isValid: emailIsValid } = emailState;
    const [userSuggestions, setUserSuggestions] = useState([]);
    const [stopSearch, setStopSearch] = useState(false)
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }

    const dispatch = useDispatch();

    useEffect(() => {
        const identifier = setTimeout(() => {
            setFormIsValid(emailIsValid);
        }, 500);
    
        return () => {
            clearTimeout(identifier);
        };
    }, [emailIsValid, emailState.value]);

    useEffect(() => {
        setStopSearch(false)
        const searchUser = async () => {
            const users = await UserPowerSearch(apiData, emailState.value, dispatch)
            console.log(users)
            const userEmailAddresses = users[0].users.map(user => user.email)
            setUserSuggestions(userEmailAddresses)
        }

        const delayDebounceFn = setTimeout(() => {
            if (emailState.value !== '' && !stopSearch){
                searchUser()
            } else {
                setUserSuggestions([])
            } 
        }, 500);
        return () => clearTimeout(delayDebounceFn);

    }, [emailState.value])

    const emailChangeHandler = (event) => {
        dispatchEmail({ type: 'USER_INPUT', val: event.target.value });
    }
    
    const validateEmailHandler = () => {
        dispatchEmail({ type: 'INPUT_BLUR' });
    }

    const onClearHandler = () => {
        dispatchEmail({ type: 'INPUT_CLEAR', val: "" })
    }

    const addUser = async () => {
        const email = emailState.value;
        if (email != '') {
            let body = {
                groupID: groupID,
                email: email,
                role: "TechSupport",
                owner: 0,
            }

            console.log(body)

            const response = await addUserToGroup(apiData, body, dispatch)
            //const response = true
            console.log(response)
            if (response.success) {
                setSuccess(true)
                setShowPrevDialogs(false)
            } else {
                setFail(true)
            }
        }
    }

    const submitHandler = (event) => {
        event.preventDefault();
        if (formIsValid) {
            addUser()
            onClearHandler();
            return;
        } else if (!emailIsValid) {
            emailInputRef.current.focus();
        }
    };

    const setSelectedEmail = (e) => {
        console.log(e)
        emailChangeHandler(e)
        setStopSearch(true)
        setUserSuggestions([])
    }

    return (
        <form onSubmit={submitHandler} className={classes["container"]} method="dialog" autoComplete="off" >
            <p style={{fontWeight:"500", fontSize:"16px", color:"#6e6e6e"}}>Search for an existing user by name or email. As you type, matching users will be suggested automatically.</p>
            <ul className={classes["inputs-list"]}>
                <li className={classes["input-container"]}>
                    <Input
                        className={classes.input}
                        placeholder={"Enter user's email address"}
                        ref={emailInputRef}
                        id="Email"
                        type={"text"}
                        isValid={emailState.isValid}
                        value={emailState.value}
                        onChange={emailChangeHandler}
                        onBlur={validateEmailHandler}
                    />

                    {userSuggestions.length > 0 && (
                        <div>
                            <ListBox 
                                value={emailState.value} 
                                onChange={setSelectedEmail} 
                                options={userSuggestions}
                                className="w-full md:w-14rem" 
                            />
                        </div>   
                    )}
                </li>

                <div>
                    {/*choose group*/}
                    
                </div>

                <div className={classes["button-container"]}>
                    <Button severity="success" disabled={!emailIsValid} type="submit" label="Add user"/>
                </div>
            </ul>
        </form>
    )
}

export default AddPortalUser;

